import React from 'react';

const Input = React.forwardRef(({ id, name, type = 'text', value, onChange, onBlur, placeholder, error, className = '', ...props }, ref) => {
  return (
    <div className={`relative ${className}`}>
      <input
        id={id}
        name={name}
        ref={ref}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className={`appearance-none block w-full px-4 py-3 border ${error ? 'border-red-300' : 'border-gray-300'} rounded-xl shadow-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all duration-150`}
        {...props}
      />

      {error && (
        <p id={`${id}-error`} className="mt-2 text-sm text-red-600">
          {error}
        </p>
      )}
    </div>
  );
});

export default Input;
